import Phaser from 'phaser';
import { Button } from './Button';

export class MessageBox extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, messageBoxWidth: number = 0, messageBoxHeight: number = 0, messages, buttons, images?, container?, bgImage?) {
    super(scene);
    const sceneCenterX = scene.physics.world.bounds.width * 0.5;
    const sceneCenterY = scene.physics.world.bounds.height * 0.5;
    if (messageBoxWidth === 0) messageBoxWidth = scene.physics.world.bounds.width * 0.8;
    if (messageBoxHeight === 0) messageBoxHeight = scene.physics.world.bounds.height * 0.8;
    this.alpha = 0;
    this.depth = 1000;
    this.width = messageBoxWidth;
    this.height = messageBoxHeight;
    this.x = sceneCenterX - messageBoxWidth / 2;
    this.y = sceneCenterY - messageBoxHeight / 2;
    if (bgImage == null) {
      bgImage = "menu-background";
    }

    const backgroundImage = scene.add
      .image(messageBoxWidth / 2, messageBoxHeight / 2, bgImage)
      .setDisplaySize(messageBoxWidth, messageBoxHeight)
      .setOrigin(0.5);
    this.add(backgroundImage);
    if (images) {
      for (const image of images) {
        const tempImage = this.scene.add
          .image(messageBoxWidth * image.x, messageBoxHeight * image.y, image.name)
          .setDisplaySize(image.width, image.height)
          .setOrigin(0.5);
        this.add(tempImage);
      }
    }

    if (container) {
      this.add(container);
    }

    messages.forEach(message => {
      const color = message.color ? message.color : '#FFFFFF';
      const fontSize = message.fontSize ? message.fontSize : '20px';
      const fontFamily = message.fontFamily ? message.fontFamily : 'sans-serif';
      const text = this.scene.add
        .text(0, message.yPos, message.text, { color: color, font: fontSize + ' ' + fontFamily, ...message.styles })
        .setOrigin(message.center ? 0.5 : 0);
      text.x = message.center ? messageBoxWidth * 0.5 : message.xPos;
      text.setAlign(message.center? 'center' : 'left')
      this.add(text);
    });

    if (buttons.length > 1) {
      let x = 0.3;
      buttons.forEach(btn => {
        let btnX = btn.x;
        if (!btnX) {
          btnX = messageBoxWidth * x;
          x = x + 0.4;
        }
        const button = new Button(scene, btnX, btn.y ? btn.y : messageBoxHeight * 0.85, btn.name, btn.method, 'button-press', btn.width, btn.height);
        this.add(button);
      });
    } else {
      const button = new Button(scene, buttons[0].x ? buttons[0].x : messageBoxWidth * 0.5, buttons[0].y ? buttons[0].y : messageBoxHeight * 0.85, buttons[0].name, buttons[0].method,'button-press', buttons[0].width, buttons[0].height);
      this.add(button);
    }
    scene.add.existing(this);
    scene.tweens.add({
      alpha: 1,
      ease: 'Linear',
      duration: 300,
      targets: this,
      repeat: 0
    });
  }
}
